<template>
    <div>

        <!-- Header -->
        <div class="pt-3 pb-1 mb-3 bg-white border-bottom">
            <div class="container">

                <div class="d-flex justify-content-between">

                    <div class="d-flex">
                        <a href="/teacher/essays/all" class="align-items-center text-sm mt-1 mt-sm-0">
                            <i class="fas fa-arrow-left mr-1"></i> Voltar <span class="d-none d-sm-inline-block">a todas as redações</span>
                        </a>
                    </div>

                </div>
                <div class="d-none d-sm-block row py-2">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="lh-md d-flex flex-column">
                            <div class="fw-medium  fs-6">
                                <span v-if="essay.student ">
                                    Aluno: {{ essay.student.name }}
                                </span>
                                <span v-if="essay.group">
                                    &#8226; {{ essay.group.name }}
                                </span>
                            </div>
                            <div class="text-black-50 fw-normal ">
                                Professor/Corretor:
                                <span v-if="essay.teacher">
                                    <span class="fw-bolder">
                                        {{ essay.teacher.name }}
                                    </span>
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </div>
                            <div class="text-black-50 fw-normal ">
                                Tema:
                                <span v-if="essay.theme">
                                    <a :href="'/teacher/themes/' + essay.theme.id" target="_blank">
                                        {{ essay.theme.title | truncate(30) }}
                                    </a>
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </div>

                            <div class="text-black-50 fw-normal ">
                                <span>Avaliação da Correção:</span>
                                <b-form-rating v-if="essay.rating" v-model="essay.rating" color="#ff8800" show-value-max readonly no-border inline show-value></b-form-rating>
                                <span v-else class="fw-bolder">Não Avaliada</span>

                            </div>

                        </div>

                        <div class="d-flex gap-3 align-items-start lh-md">
                            <div class="d-flex flex-column justify-content-end text-end">
                                <div class="">

                                    <span v-if="essay.status === 'BLOCK'" class="px-2 py-1 rounded-pill text-warning" style="background-color: #ffc10720;">
                                        Aguardando Devolução
                                    </span>

                                    <span v-if="essay.status === 'WAIT'" class="px-2 py-1 rounded-pill text-danger" style="background-color: #dc354520;">
                                        Aguardando
                                    </span>

                                    <span v-if="essay.status === 'IN_PROGRESS'" class="px-2 py-1 rounded-pill text-info" style="background-color: #0dcaf020;">
                                        Em Andamento
                                    </span>

                                    <span v-if="essay.status === 'OKAY'" class="w-auto px-2 py-1 rounded-pill text-success" style="background-color: #19875420;">
                                        Corrigida
                                    </span>

                                </div>
                                <div class="text-black-50 fw-normal">
                                    Última atualização: {{ essay.updated_at | moment('from', 'now') }}
                                </div>
                                <div class="text-black-50 fw-normal">
                                    Enviada: {{ essay.created_at | moment('from', 'now') }}
                                </div>
                                <div class="text-black-50 fw-normal" >
                                    <span v-if="essay.mode">
                                        Modo: {{ essay.mode.name }}
                                    </span>
                                    <span v-else-if="essay.theme">
                                        Modo: {{ essay.theme.mode.name  }}
                                    </span>
                                    <span v-else>
                                        Modo: ---
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex flex-column gap-2">

                                <div class="d-flex gap-2" >
                                    <span class="btn btn-outline-info border rounded-sm h-auto p-1" role="button" v-if="essay.status === 'OKAY'" :disabled="loading" @click="inProgressCorrection" v-b-tooltip.hover title="Editar Redação">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
                                          </svg>
                                    </span>
                                    <span class="btn btn-outline-success border rounded-sm h-auto p-1" role="button" v-if="essay.status === 'IN_PROGRESS'" :disabled="loading" @click="essay.reviews.length === 0 && canRevisorTeacher ? showConfirmation() : finishCorrection()" v-b-tooltip.hover title="Finalizar Correção">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                          </svg>
                                    </span>
                                    <span class="btn btn-outline-primary border rounded-sm h-auto p-1" role="button" v-if="essay.status === 'WAIT' || essay.status === 'BLOCK'" :disabled="loading" @click="startCorrection" v-b-tooltip.hover title="Iniciar Correção">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                                          </svg>
                                    </span>
    
                                    <a :href="'/teacher/essays/' + essay.id + '/export'" v-if="essay.status === 'OKAY'" class="border border-black rounded-sm h-auto p-1 text-black" role="button" target="_blank" v-b-tooltip.hover title="Baixar PDF">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                          </svg>
                                    </a>
                                    <span class="border border-black rounded-sm h-auto p-1" role="button" v-if="essay.status === 'OKAY' || essay.status === 'IN_PROGRESS'" :disabled="loading" @click="waitCorrection" v-b-tooltip.hover title="Mudar Status Para Aguardando Correção">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                                          </svg>
    
                                    </span>
    
                                    <span class="text-warning border border-black rounded-sm h-auto p-1" role="button" :disabled="loading" @click="blockEssay" v-b-tooltip.hover title="Problemas na correção">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                          </svg>
                                    </span>
                                    <span v-if="canDestroyCorrection" class="text-danger border border-black rounded-sm h-auto p-1" role="button" :disabled="loading" @click="destroyCorrection" v-b-tooltip.hover title="Deletar Redação">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                          </svg>
    
                                    </span>
                                    
                                </div>
                                <div class="d-flex gap-2">
                                    <span v-if="canNoNoteEssay && essay.status === 'IN_PROGRESS'" @click="handleNoNoteEssay" class="text-info border border-black rounded-sm h-auto p-1" role="button" :disabled="loading" v-b-tooltip.hover title="Marcar/Desmarcar sem nota">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                                            <path stroke-linecap="round" stroke-linejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
                                          </svg>                                                                          
                                    </span>
                                    <span v-if="review && essay.status != 'OKAY'" @click="reviewEssay" class="text-info border border-black rounded-sm h-auto p-1" role="button" :disabled="loading" v-b-tooltip.hover title="Revisar Redação">
                                        <svg class="icon-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12" />
                                        </svg>                                          
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--mobile -->
                <div class="d-block d-sm-none row py-2 mt-2">
                    <div class="d-flex justify-content-between gap-3 align-items-center lh-md">
                        <div class="d-flex flex-column justify-content-end text-end">
                            <div class="">

                                <span v-if="essay.status === 'BLOCK'" class="px-2 py-1 rounded-pill text-warning" style="background-color: #ffc10720;">
                                    Aguardando Devolução
                                </span>

                                <span v-if="essay.status === 'WAIT'" class="px-2 py-1 rounded-pill text-danger" style="background-color: #dc354520;">
                                    Aguardando
                                </span>

                                <span v-if="essay.status === 'IN_PROGRESS'" class="px-2 py-1 rounded-pill text-info" style="background-color: #0dcaf020;">
                                    Em Andamento
                                </span>

                                <span v-if="essay.status === 'OKAY'" class="w-auto px-2 py-1 rounded-pill text-success" style="background-color: #19875420;">
                                    Corrigida
                                </span>

                            </div>

                        </div>
                        <div class="dropdown" >
                            <button role="button" class="btn btn-sm btn-light text-black" data-bs-toggle="dropdown">
                                <svg xmlns="http://www.w3.org/2000/svg" height="22px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                </svg>
                            </button>
                            <ul class="dropdown-menu">
                                <li>
                                    <span class="dropdown-item text-info px-2" role="button" v-if="essay.status === 'OKAY'" :disabled="loading" @click="inProgressCorrection" >
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
                                        </svg>
                                        Editar Redação
                                    </span>
                                    <span class="dropdown-item text-success px-2" role="button" v-if="essay.status === 'IN_PROGRESS'" :disabled="loading" @click="essay.reviews.length === 0 && canRevisorTeacher ? showConfirmation() : finishCorrection()" >
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                        </svg>
                                        Finalizar Correção
                                    </span>
                                    <span class="dropdown-item text-primary px-2" role="button" v-if="essay.status === 'WAIT' || essay.status === 'BLOCK'" :disabled="loading" @click="startCorrection" >
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                                        </svg>
                                          Iniciar Correção
                                    </span>
                                </li>
                                <li>

                                    <a :href="'/teacher/essays/' + essay.id + '/export'" v-if="essay.status === 'OKAY'" class="px-2 dropdown-item text-black" target="_blank">
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                        </svg>
                                        Baixar PDF
                                    </a>
                                </li>
                                <li>

                                    <span class="dropdown-item px-2" role="button" v-if="essay.status === 'OKAY' || essay.status === 'IN_PROGRESS'" :disabled="loading" @click="waitCorrection">
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
                                          </svg>
                                          Mudar Para Aguardando Correção
                                    </span>
                                </li>
                                <li>

                                    <span class="text-black dropdown-item px-2" role="button" :disabled="loading" @click="blockEssay" >
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                          </svg>
                                          Problemas na correção
                                    </span>
                                </li>
                                <li>

                                    <span v-if="canDestroyCorrection" class="text-danger dropdown-item px-2" role="button" :disabled="loading" @click="destroyCorrection">
                                        <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                          </svg>
                                          Deletar Redação

                                    </span>
                                </li>
                            </ul>



                        </div>
                    </div>
                    <div class="lh-sm d-flex flex-column mt-2">
                        <div class="fw-medium  fs-6">
                            <span v-if="essay.student ">
                                Aluno: {{ essay.student.name }}
                            </span>
                            <span v-if="essay.group">
                                &#8226; {{ essay.group.name }}
                            </span>
                        </div>
                        <div class="text-black-50 fw-normal ">
                            Professor/Corretor:
                            <span v-if="essay.teacher">
                                <span class="fw-bolder">
                                    {{ essay.teacher.name }}
                                </span>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </div>

                        <div class="text-black-50 fw-normal ">
                            Tema:
                            <span v-if="essay.theme">
                                <a :href="'/teacher/themes/' + essay.theme.id" target="_blank">
                                    {{ essay.theme.title | truncate(30) }}
                                </a>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </div>
                        <div class="text-black-50 fw-normal" >
                            <span v-if="essay.mode">
                                Modo: {{ essay.mode.name }}
                            </span>
                            <span v-else-if="essay.theme">
                                Modo: {{ essay.theme.mode.name  }}
                            </span>
                            <span v-else>
                                Modo: ---
                            </span>
                        </div>

                    </div>
                    <div class=" w-100 border-top mt-2 pt-2 mx-2"></div>
                    <div class="lh-sm text-black-50 fw-normal">
                        Última atualização: {{ essay.updated_at | moment('from', 'now') }}
                    </div>
                    <div class="lh-sm text-black-50 fw-normal">
                        Enviada: {{ essay.created_at | moment('from', 'now') }}
                    </div>
                </div>
                <!--

                    <div class="row">


                        <dl class="col-sm-3" v-if="essay.status === 'OKAY'">
                            <dt>
                                Avaliação da Correção pelo Aluno
                            </dt>

                        </dl>

                    </div>
                -->

            </div>
        </div>
        <div class="container">
            <b-alert v-if="essay.student.observation" class="" fade variant="info" dismissible show>
                {{ essay.student.observation }}
            </b-alert>

            <b-alert v-if="essay.status === 'BLOCK'" fade variant="warning" dismissible show>
                Justificativa para o corretor devolver a redação: <b>{{ essay.block_message }}</b>
            </b-alert>

            <b-alert v-if="essay.status === 'WAIT'"  fade variant="warning" dismissible show>
                Aguardando a correção ser iniciada. Você pode começar a correção no botão acima com o icone de "Play".
            </b-alert>

            <b-alert v-if="essay.status === 'OKAY' && essay.no_note"  fade variant="warning" dismissible show>
                Redação marcada <b>sem nota</b> o aluno não irá ter acesso ao campo de notas.
            </b-alert>
        </div>

        <div class="container" v-if="!essay.no_note">
            <div class="row">
                <!-- Note -->
                <note @changed="getFields" :cannot-edit-color="!isAdmin" :essay-id="essay.id"></note>
            </div>
        </div>

        <!-- Content -->
        <div class="container">



            <div class="row">
                <div class="col-lg-9">

                    <!-- Content Img -->
                    <div v-if="essay.new_version">
                        <div v-if="zoom">
                            <content-img-new-zoom ref="ContentImgNewZoomRef" :modes="modes" :essay="essay" v-if="essay.content_type === 'IMG'"></content-img-new-zoom>
                        </div>

                        <div v-else>
                            <content-img-new ref="ContentImgNewRef" :modes="modes" :essay="essay" v-if="essay.content_type === 'IMG'" ></content-img-new>
                        </div>
                    </div>
                    <div v-else>

                        <content-img :essay="essay" @annotations="getAnnotations" v-if="essay.content_type === 'IMG'" ></content-img>

                    </div>

                    <observations :essay="essay" :comment-full="commentFull" v-if="commentFull"></observations>

                </div>
                <div class="col-lg-3">


                    <!-- Observations -->
                    <observations :essay="essay" :comment-full="commentFull" v-if="!commentFull"></observations>

                    <!-- History -->
                    <div class="d-flex flex-column flex-xl-row gap-3 mb-4 fw-normal">

                        <last-essays :student-id="essay.student_id" :modal-id="'modal' + essay.id" :mode-button="true"></last-essays>
                        <div v-if="telegram" class="">
                            <a :href="telegram" target="_blank" class="btn-link text-info" v-b-tooltip.hover title="Aqui você pode ir para o Telegram do seu Professor/Mentor">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="icons mr-1" viewBox="0 0 512 512">
                                    <path d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"/>
                                </svg>
                                Telegram
                            </a>
                        </div>
                    </div>

                    
                    

                    <!-- Áudio -->
                    <essay-audio-multiple :essay="essay"></essay-audio-multiple>
                    <!-- Documents -->
                    <essay-documents :essay="essay"></essay-documents>




                    <!-- Block Essay -->
                    <block-essay :essay-id="essay.id"></block-essay>

                    <review-modal v-if="review"></review-modal>

                    <review-teacher-modal :teachers="teachers" @created="reviewTeacherCreated"></review-teacher-modal>

                    <b-modal id="confirmation"
                        ok-title="Adicionar Revisor"
                        cancel-title="Finalizar Correção"
                        @ok="handleOk"
                        @cancel="handleCancel"
                    >
                        Essa redação não possui um revisor ainda, deseja adicionar?
                    </b-modal>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContentImg from "./CorrectionComponentsNew/ContentImg";
import ContentImgNew from "./CorrectionComponentsNew/ContentImgNew";
import ContentImgNewZoom from "./CorrectionComponentsNew/ContentImgNewZoom";
import Note from './CorrectionComponentsNew/Note'
import Observations from "./CorrectionComponentsNew/Observations";
import EssayAudio from './CorrectionComponentsNew/Audio';
import EssayAudioMultiple from './CorrectionComponentsNew/AudioMultiple';
import EssayDocuments from './CorrectionComponentsNew/Documents.vue';
import BlockEssay from "./CorrectionComponentsNew/BlockEssay";
import LastEssays from '../LastEssaysNew'
import ReviewModal from './ReviewModal.vue';
import ReviewTeacherModal from './ReviewTeacherModal.vue';

export default {
    components: {
        ContentImg,
        ContentImgNew,
        ContentImgNewZoom,
        Note,
        Observations,
        EssayAudio,
        EssayAudioMultiple,
        EssayDocuments,
        BlockEssay,
        LastEssays,
        ReviewModal,
        ReviewTeacherModal
    },
    props: ['essay', 'commentFull', 'telegram', 'zoom', 'canDestroyCorrection', 'canNoNoteEssay', 'review', 'canRevisorTeacher', 'teachers', 'isAdmin'],
    data() {
        return {
            loading: false,
            annotations: [],
            modes: {
                field: []
            }
        }
    },
    created(){
        this.getFields()
    },
    mounted(){

        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                const toggle = document.getElementById('sidebarToggle')
                toggle.click()

            }
        }
    },
    methods: {
        reviewTeacherCreated(){
            window.location.reload();
        },

        handleOk() {
            this.$root.$emit('ReviewTeacher', this.essay);
            this.$bvModal.hide('confirmation');
        },
        handleCancel() {
            this.$bvModal.hide('confirmation');
            this.finishCorrection();
        },
        rotate(){
            if(this.essay.new_version){
                if(this.zoom){

                    this.$refs.ContentImgNewZoomRef.rotateEssay()
                    return
                }
                this.$refs.ContentImgNewRef.rotateEssay()
                return
            }

        },

        getAnnotations(annotations) {
            this.annotations = annotations
        },
        showConfirmation(){
            this.$bvModal.show('confirmation');
        },

        finishCorrection() {
            if(confirm('Deseja finalizar essa correção ? Um email será enviado para o aluno avisando que já está disponível a sua correção. ')) {
                this.loading = true;
                axios.put('/teacher/essays/' + this.essay.id + '/change-status', {
                    status: 'OKAY'
                })
                .then((result) => {

                    this.$toast.success('Redação Corrigida :)')

                    // Reload
                    window.location.reload();

                })
                .catch((error) => {
                    this.$toast.error('O status da redação não foi alterado :( Entre em contato com o suporte ')
                })
                .finally(() => this.loading = false)
            }
        },

        inProgressCorrection() {
            if (confirm('Deseja voltar o status da redação e fazer algum ajuste ? A redação irá para o status de "em progresso" para o aluno.')) {
                this.loading = true;
                axios.put('/teacher/essays/' + this.essay.id + '/change-status', {
                    status: 'IN_PROGRESS'
                })
                    .then((result) => {
                        // Reload
                        window.location.reload();
                    })
                    .catch((error) => {
                        this.$toast.error('O status da redação não foi alterado :( Entre em contato com o suporte ')
                    })
                    .finally(() => this.loading = false)
            }
        },

        waitCorrection() {
            if (confirm('Deseja voltar o status da redação e fazer algum ajuste ? A redação irá para o status de "aguardando correção" para o aluno.')) {
                this.loading = true;
                axios.put('/teacher/essays/' + this.essay.id + '/change-status', {
                    status: 'WAIT'
                })
                    .then((result) => {

                        // Reload
                        window.location.reload();

                    })
                    .catch((error) => {

                        this.$toast.error('O status da redação não foi alterado :( Entre em contato com o suporte ')

                    })
                    .finally(() => this.loading = false)
            }
        },

        startCorrection() {
            if (confirm('Deseja iniciar a correção da redação ?')) {
                this.loading = true;
                axios.put('/teacher/essays/' + this.essay.id + '/change-status', {
                    status: 'IN_PROGRESS'
                })
                    .then((result) => {

                        // Reload
                        window.location.reload();

                    })
                    .catch((error) => {

                        this.$toast.error('O status da redação não foi alterado :( Entre em contato com o suporte ')

                    })
                    .finally(() => this.loading = false)
            }
        },

        destroyCorrection() {
            if (confirm('Tem certeza que deseja deletar essa redação?')) {
                this.loading = true;
                axios.delete('/teacher/essays/' + this.essay.id)
                    .then((result) => {

                        // Callback
                        this.$emit('destroyed')

                        // Close Modal
                        this.$bvModal.hide('destroy')

                        // Message
                        this.$toast.success('Redação deletada com sucesso !')

                        // Redirect
                        this.redirectIfNeed(result)
                    })
                    .finally(() => this.loading = false)
            }
        },

        blockEssay() {
            this.$root.$emit('blockEssay', this.essay);
        },

        handleNoNoteEssay(){
            this.loading = true
            axios.put('/teacher/essays/' + this.essay.id + '/no-note')
                .then((result) => {
                    this.$toast.success(this.essay.no_note ? 'Redação desmarcada sem nota!' : 'Redação marcada sem nota!')
                    window.location.reload();
                    
                }).catch((err) => {
                    this.$toast.error(this.essay.no_note ? 'Erro ao desmarcar sem nota!' :'Erro ao marcar redação sem nota!')
                }).finally(()=> {this.loading = false});
        },

        reviewEssay() {
            this.$root.$emit('ReviewEssay', this.review);
        },

        getFields(){
            
            axios.get('/teacher/modes/'+this.essay.id)
            .then((result) => {
                const response = result.data.data;
                let modes = null
                // Mode
                if (response.essay.theme) {
                    modes = response.essay.theme.mode;
                } else {
                    modes = response.essay.mode;
                }

                
                return this.modes = modes
            })
        }
    }
}
</script>

<style scoped>
    @keyframes spin {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    a:hover .spinner {
        animation-name: spin;
        animation-duration: 2s;
    }

    .icon-lg{
        height: 24px;
    }
    .icons{
        height: 16px;
    }
</style>
